module.exports = __webpack_public_path__ + "static/img/enfei.08394a71.png";